module.exports = __webpack_public_path__ + "img/wrzl6.67761057.webp";